import React from 'react'
import { mdiAlert } from '@mdi/js'

import { ClaimDeviceH4 } from '../styles'
import {
  ClaimDeviceErrorContainer,
  ClaimDeviceErrorDescription,
  ClaimDeviceErrorIcon,
  ClaimDeviceErrorRetryButton,
  ClaimDeviceErrorSpan,
} from './styles'

interface QrCodeScanUnknownErrorProps {
  onEraseDataClick: () => void
}

// TODO: Localize
function QrCodeScanUnknownError({
  onEraseDataClick,
}: QrCodeScanUnknownErrorProps) {
  return (
    <ClaimDeviceErrorContainer>
      <ClaimDeviceErrorIcon path={mdiAlert} size={2} />
      <ClaimDeviceH4>Error</ClaimDeviceH4>
      <ClaimDeviceErrorDescription>
        <ClaimDeviceErrorSpan>Something went wrong initializing scanner</ClaimDeviceErrorSpan>
        <ClaimDeviceErrorSpan>
          Use manual claiming or try again.
        </ClaimDeviceErrorSpan>
      </ClaimDeviceErrorDescription>
      <ClaimDeviceErrorRetryButton
        variant="primary"
        type="button"
        onClick={onEraseDataClick}
      >
        Retry
      </ClaimDeviceErrorRetryButton>
    </ClaimDeviceErrorContainer>
  )
}

export default QrCodeScanUnknownError
